import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip, Legend } from 'chart.js';

// Register Chart.js components
Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip, Legend);

document.addEventListener('turbo:load', function() {
  
  /* --------------------------------------------------
                Create Individual Charts
  -------------------------------------------------- */
  const createIndividualChart = (canvasId, data, color, label) => {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;

    const chartLabels = JSON.parse(canvas.getAttribute('data-months'));
    const chartData = JSON.parse(canvas.getAttribute('data-values'));
    const chartColor = canvas.getAttribute('data-color');

    new Chart(canvas, {
      type: 'line',
      data: {
        labels: chartLabels,
        datasets: [{
          label: label,
          data: chartData,
          borderColor: chartColor,
          backgroundColor: hexToRgba(chartColor, 0.1),
          tension: 0.4,
          fill: true
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { intersect: false },
        plugins: { 
          legend: { 
            display: false,
            labels: {
              font: {
                family: 'Geist, sans-serif'
              }
            }
          } 
        },
        animation: { duration: 300 },
        scales: {
          x: { 
            display: true, 
            ticks: { 
              color: '#6b7280',
              font: {
                family: 'Geist, sans-serif'
              }
            }, 
            grid: { color: '#e5e7eb' } 
          },
          y: { 
            display: true, 
            ticks: { 
              color: '#6b7280',
              font: {
                family: 'Geist, sans-serif'
              }
            }, 
            grid: { color: '#e5e7eb' } 
          }
        }
      }
    });
  };

  // Helper function to convert hex to rgba
  const hexToRgba = (hex, alpha = 1) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  /* --------------------------------------------------
                Initialize All Charts
  -------------------------------------------------- */
  createIndividualChart('projectsChart', null, null, 'Projects Posted');
  createIndividualChart('downloadsChart', null, null, 'Downloads');
  createIndividualChart('customersChart', null, null, 'New Customers');

}); 